// Schlanker Klient-API-Client — bewusst getrennt vom Sachbearbeiter-`client.ts`
// (dessen Refresh-on-401 wuerde bei abgelaufener Klient-Session faelschlich den
// Sachbearbeiter-Refresh ziehen). Hier: kein Refresh — 401 = Session verwerfen.

import {
  clearKlientSession,
  getKlientSession,
  type KlientSession,
} from "./session";

const BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";

export class KlientApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

/** Einmal-Token gegen eine Klient-Session eintauschen (`POST /redeem`). */
export async function redeem(token: string): Promise<KlientSession> {
  const res = await fetch(`${BASE_URL}/api/invitations/redeem`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ token }),
  });
  if (!res.ok) {
    throw new KlientApiError(
      "Einladung ungültig oder abgelaufen",
      res.status
    );
  }
  const data = await res.json();
  return { access_token: data.access_token, branding: data.branding };
}

export interface KlientUploadResult {
  id: string;
  original_filename: string;
  file_size_bytes: number;
  duplicate: boolean;
}

/** Eine Datei mit der Klient-Session hochladen (`POST /api/upload`). */
export async function uploadBeleg(file: File): Promise<KlientUploadResult> {
  const session = getKlientSession();
  if (!session) {
    throw new KlientApiError("Keine Sitzung", 401);
  }

  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${BASE_URL}/api/upload`, {
    method: "POST",
    // FormData: KEIN Content-Type setzen — der Browser baut den boundary-Header.
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      Accept: "application/json",
    },
    body: form,
  });

  if (res.status === 401) {
    // Session abgelaufen → verwerfen; der Aufrufer zeigt die Hinweis-Seite.
    clearKlientSession();
    throw new KlientApiError("Sitzung abgelaufen", 401);
  }
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.json();
      if (body?.detail) detail = String(body.detail);
    } catch {
      /* kein JSON-Body — statusText reicht */
    }
    throw new KlientApiError(detail, res.status);
  }

  return (await res.json()) as KlientUploadResult;
}
